/* eslint-disable react/prop-types */

import React, { PureComponent } from 'react';
// import { connect } from 'react-redux';
// import checkoutReducer, { actions } from 'modules/checkout';
// import adminReducer, { actions as adminActions } from 'modules/admin';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Header from 'components/Header';
import Search from './containers/Search';
import Results from './containers/Results';


class Refunds extends PureComponent {
  componentDidMount() {
    window.onbeforeunload = () => false;
  }

  render() {
    return (
      <Grid container>
        <Header />
        <Search />
        <Results />
      </Grid>
    );
  }
}

export default Refunds;


// WEBPACK FOOTER //
// ./routes/Orders/containers/Refunds/index.jsx